import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Text } from "react-internationalization";
import {
  emailProgress,
  saveLogout,
} from "../../../Redux/Actions/webAppActions";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import SimpleReactValidator from "simple-react-validator";
import history from "../../../Utils/History";

const ProgressModal = (props) => {
  const [email, setEmail] = useState("");
  const [snackbar, setsnackbar] = useState({
    snackBarOpen: false,
    snackBarMsg: "",
    snackBarSeverty: "",
    vertical: "top",
    horizontal: "center",
  });
  const [showpopUp, setshowpopUp] = useState(false);
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.webApp.language);
  //const userId=useSelector((state) => state.login.userId);
  const { isPage } = useSelector((state) => state.spinner);
  const validator = new SimpleReactValidator();
  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSend = async () => {
    if (
      isPage === "enrollOnline" &&
      (!props.state.data.birthDate || !props.state.data.lastName)
    ) {
      props.setOpen(false);
      setsnackbar({
        snackBarOpen: true,
        snackBarMsg:
          lang === "es"
            ? "Por favor complete el apellido y la fecha de nacimiento para guardar su progreso"
            : "Please fill last name and birthdate to save your progress",
        snackBarSeverty: "error",
      });
    } else {
      if (!email) {
        props.setOpen(false);
        setsnackbar({
          snackBarOpen: true,
          snackBarMsg:
            lang === "es"
              ? "Por favor ingrese el correo electrónico"
              : "Please enter email",
          snackBarSeverty: "error",
        });
      } else {
        if (!validator.check(email, "email")) {
          setsnackbar({
            snackBarOpen: true,
            snackBarMsg:
              lang === "es"
                ? "Por favor introduzca una dirección de correo electrónico válida"
                : "Please enter a valid email",
            snackBarSeverty: "error",
          });
        } else {
          let appId;
          if (isPage === "enrollOnline") {
            const payloads = props.getData(props.state);
            props.setOpen(false);
            const saveLogoutRes = await dispatch(saveLogout(payloads));
            if (
              saveLogoutRes.status === 500 &&
              saveLogoutRes.data.message === "Application is already submitted"
            ) {
              props.setOpen(false);
              setshowpopUp(true);
              return;
            }
            if (saveLogoutRes?.status != "OK") {
              //props.setOpen(false)
              //let msg=saveLogoutRes?.message?saveLogoutRes?.message:saveLogoutRes?.data?.message
              await setsnackbar({
                snackBarOpen: true,
                snackBarMsg:
                  lang === "es"
                    ? "Error del sistema. Inténtelo más tarde."
                    : "System error. Please try later.",
                snackBarSeverty: "error",
              });
              return;
            }
            // console.log("enroll=>", saveLogoutRes);
            appId = saveLogoutRes.data;
          }
          let url =
            window.location.href +
            "?" +
            "&" +
            "customerId=" +
            window.btoa(props.customerId) +
            "&" +
            "zipCd=" +
            //this.props.zipCode+
            window.btoa(props.zip) +
            "&" +
            "countyCd=" +
            //this.props.CountyCd+
            window.btoa(props.CountyCd) +
            "&" +
            "stateCd=" +
            //this.props.stateCd+
            window.btoa(props.stateCd) +
            "&" +
            "countyName=" +
            //this.props.countyName.trim()+
            window.btoa(props.countyName?.trim()) +
            "&" +
            "productIds=" +
            //productId.trim()+
            window.btoa(props.selectedPlansForCompare) +
            //this.props.dataSet.plandetails[0].productId.trim()+
            "&" +
            "email=" +
            window.btoa(email) +
            "&" +
            "deepLink=true" +
            "&" +
            "planCompare=true" +
            "&" +
            "productCategory=" +
            window.btoa(props.productCategory) +
            "&" +
            "selectedPlanName=" +
            window.btoa(props.selectedPlanName) +
            "&" +
            "appId=" +
            window.btoa(appId) +
            "&" +
            "year=" +
            window.btoa(props.year) +
            "&" +
            "lang=" +
            window.btoa(props.lang);

          let payload = {
            emailId: email,
            url: url,
            lang: props.lang,
          };
          let response = await dispatch(emailProgress(payload));

          //let response = await this.props.sendEmail(payload);
          if (response.status === "OK") {
            props.setOpen(false);
            setsnackbar({
              snackBarOpen: true,
              snackBarMsg:
                lang === "es"
                  ? isPage === "enrollOnline"
                    ? "Enlace para su ID de solicitud:" +
                      appId +
                      " ha sido enviado a la dirección de correo electrónico:" +
                      email
                    : "El correo enviado con éxito"
                  : isPage === "enrollOnline"
                  ? "Link for your Application ID :" +
                    appId +
                    " has been sent to the email address :" +
                    email
                  : "Mail sent successfully",
              snackBarSeverty: "success",
            });
            setTimeout(() => {
              props.setOpen(false);
              history.push("/e-Enroll/userLogin");
            }, 4000);
          } else {
            setsnackbar({
              snackBarOpen: true,
              snackBarMsg:
                lang === "es"
                  ? "Ocurrió un error al enviar el correo electrónico."
                  : "Error occured while sending email.",
              snackBarSeverty: "error",
            });
          }
        }
      }
    }
  };
  const handleClose = (event, reason) => {
    setsnackbar({
      snackBarOpen: false,
      snackBarSeverty: "",
      snackBarMsg: "",
      vertical: "top",
      horizontal: "center",
    });
  };
  const Okhandler = () => {
    setshowpopUp(false);
    history.push("/e-Enroll/userLogin");
  };
  // useEffect(() => {
  //   //setEmail(props.userId);
  //   setEmail(props?.state?.data?.emailAddress)
  // }, [props?.state?.data?.emailAddress]);
  // useEffect(() => {
  //   setEmail(props?.userId);
  // }, []);
  useEffect(() => {
    setEmail(
      props?.state?.data?.emailAddress
        ? props?.state?.data?.emailAddress
        : props?.userId
    );
  }, [props?.userId, props?.state?.data?.emailAddress]);
  return (
    <>
      <Snackbar
        open={snackbar.snackBarOpen}
        //  autoHideDuration={6000}
        onClose={handleClose}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        key={snackbar.vertical + snackbar.horizontal}
      >
        <Alert onClose={handleClose} severity={snackbar.snackBarSeverty}>
          {snackbar.snackBarMsg}
        </Alert>
      </Snackbar>
      <div
        className="modal fade z-index-1052 show"
        id="save_your_progress_window"
        role="dialog"
        aria-modal="true"
        style={{ display: props.isOpen ? "block" : "none" }}
      >
        <Modal show={showpopUp} backdrop="static" onHide={Okhandler} centered>
          <Modal.Body>
            {/* <h4 class="section-head">Session Timed out </h4> */}
            <div>
              <p>Application is already submitted.</p>
              <p>Please create a new application</p>
            </div>
            <button
              onClick={Okhandler}
              className="btn-primary-continue mr-3 idle-yes"
            >
              OK
            </button>
          </Modal.Body>
        </Modal>

        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h4>
                <Text id="sharp.saveYourProgress" />
              </h4>
              <button
                type="button"
                className="btn-close close"
                data-bs-dismiss="modal"
                onClick={() => props.setOpen(false)}
              />
            </div>
            <div className="modal-body">
              <label htmlFor="email_address" className="form-label fixed-label">
                <Text id="sharp.email" />
              </label>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                id="email_address"
                name="email_address"
                type="text"
                className="form-control"
                onChange={handleChange}
                value={email}
                disabled={isPage === "enrollOnline"}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-shp btn-shp-default"
                data-bs-dismiss="modal"
                onClick={handleSend}
              >
                <Text id="sharp.sendMeLink" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgressModal;
